import React from "react";
import { ReactComponent as YoutubeIcon } from "../../assets/Updated-imagery/youtubeCardIcon.svg";
import { ReactComponent as BooksIcon } from "../../assets/Updated-imagery/booksIcon.svg";
import textDecore from "../../assets/Updated-imagery/textDecore.png";
const AboutSection = () => {
    return (
        <section className="relative mb-20 pb-20 w-full bg-transparent overflow-hidden">
            <div className="w-full">
                <div className="flex flex-col md:flex-row gap-10 items-center w-full justify-between">
                    <div className=" basis-full md:basis-1/2 rounded-3xl p-8 ">
                        <div className="text-center relative flex-center-both flex-col space-y-1 font-ibm">
                            <p className="text-tomato-400 text-lg mb-4 font-medium">
                                – أستاذك وليد محسن
                            </p>
                            {/* الرسالة الرئيسية */}
                            <div className="space-y-2 bg-white/20 backdrop-blur-[2px] font-ibm relative py-1 w-fit px-2 ">
                                <p className="text-black relative z-3 text-4xl font-semibold">
                                    أنا مش بس بعلّمك عربي...
                                    <br />
                                    أنا بجهّزك تبقى جاهز لأي سؤال
                                    <br />
                                    في{" "}
                                    <span className="text-tomato-500 font-bold">
                                        الامتحان والحياة
                                    </span>
                                </p>
                            </div>
                            <img
                                src={textDecore}
                                alt="أستاذي#في#اللغة#العربية"
                                className="absolute -z-10 -bottom-10 mx-auto w-[150px] md:w-[500px] h-auto opacity-100"
                            />
                        </div>
                    </div>
                    <div className=" basis-full md:basis-1/2 flex-center-both flex-col md:flex-row gap-3">
                        <div className="flex justify-center w-[300px] md:w-[370px]  space-y-3 flex-col">
                            <div className="bg-gradient-to-r h-[80px] md:h-[90px] from-tomato-300/30 to-secYellow-300/30 rounded-3xl p-6 text-center flex items-center justify-center">
                                <p className="text-3xl font-ibm opacity-50 font-medium">
                                    ما النجاح{" "}
                                    <span className="text-tomato-500 font-bold">إلا لحظة</span>
                                </p>
                            </div>
                            <div className="bg-gradient-to-br overflow-hidden relative h-[270px] from-yellow-100 to-yellow-200 rounded-3xl p-8 text-center shadow-lg">
                                <div className="flex flex-col items-start space-y-1 absolute top-5 left-5">
                                    <div className="flex items-center">
                                        <div className="rounded-lg px-2 ">
                                            <BooksIcon className="w-[72px] h-[72px] text-white fill-current" />
                                        </div>
                                        <span className="text-5xl font-lama font-bold text-gray-800">
                                            +400K
                                        </span>
                                    </div>
                                    <p className="text-gray-700 text-2xl font-ibm font-medium">
                                        اختصروا الطريق واتأسسوا صح
                                    </p>
                                </div>
                                <div className=" rounded-lg px-2 opacity-10 absolute -bottom-1/4 -right-1/4 ">
                                    <BooksIcon className="w-[256px] h-[256px] text-white fill-current" />
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center flex-col-reverse w-[300px] md:w-[370px] gap-3 md:flex-col">
                            <div className="bg-gradient-to-br overflow-hidden relative h-[270px] from-yellow-100 to-yellow-200 rounded-3xl p-8 text-center shadow-lg">
                                <div className="flex flex-col items-start space-y-1 absolute top-5 left-5">
                                    <div className="flex items-center">
                                        <div className=" rounded-lg px-2 ">
                                            <YoutubeIcon className="w-[72px] h-[72px] text-white fill-current" />
                                        </div>
                                        <span className="text-5xl font-lama font-bold text-gray-800">
                                            +360K
                                        </span>
                                    </div>
                                    <p className="text-gray-700 text-3xl font-ibm font-medium">
                                        مشترك علي اليوتيوب
                                    </p>
                                </div>
                                <div className=" rounded-lg px-2 opacity-10 absolute -bottom-1/4 -right-1/4 ">
                                    <YoutubeIcon className="w-[256px] h-[256px] text-white fill-current" />
                                </div>
                            </div>
                            <div className="bg-gradient-to-r h-[90px] from-tomato-300/30 to-secYellow-300/30 rounded-3xl p-6 text-center flex items-center justify-center">
                                <p className="text-3xl font-ibm opacity-50 font-medium">
                                    تهزم فيها{" "}
                                    <span className="text-tomato-500 font-bold">شهوة</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
